// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"5c389dbe","247":"7f9d64db","706":"711ede07","832":"b448c407","857":"54083301"}[chunkId] + ".chunk.js";
};